import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { SensorSlot } from "../../../../types/types";
import { Label } from "../../../../ui/Label/Label";
import { SelectButton } from "../../../../ui/SelectButton/SelectButton";
import { Button } from "../../../../ui/Button";

type Props = {
  equipmentId: string;
  updateList: Function;
};

type SelectOption = {
  value: string;
  label: string;
};

const defaultValues = {
  device: null,
  sensor: null,
  idle_level: null,
  date: null,
};

const AddDevice = ({ equipmentId, updateList }: Props) => {
  const allDevices = useAppStore((state) => state.devices);

  const [device, setDevice] = useState<SelectOption | any>();
  const [sensorsList, setSensorsList] = useState<Array<SelectOption>>();
  const [sensor, setSensor] = useState<SelectOption>();

  const devicesList: Array<SelectOption> = [];
  allDevices?.forEach((item) => {
    devicesList.push({ label: item.attributes.serial_number, value: item.id });
  });

  const [{ response: sensorsResponse, isLoading: sensorsIsLoading, error: sensorsError }, doFetchSensors] = useFetch(
    `/devices/devices/${device?.value}`
  );

  useEffect(() => {
    if (device) doFetchSensors();
  }, [device]);

  // Запрос списка датчиков для выбранного устройства
  useEffect(() => {
    if (!sensorsResponse) {
      return;
    }
    const sensorsSlotsData = sensorsResponse.data.attributes.slots as unknown as SensorSlot[];
    const newSensorsList: SelectOption[] = [];
    sensorsSlotsData.forEach((slotItem) => {
      slotItem.sensors.forEach((sensorItem) => {
        if (sensorItem.equipment_item_id === null) {
          newSensorsList.push({
            value: String(sensorItem.id),
            label:
              sensorsSlotsData.length > 1
                ? `${t(sensorItem.sensor_type.data_key_name)} | ${t("slot")} ${slotItem.number}`
                : `${t(sensorItem.sensor_type.data_key_name)}`,
            //data_key_name: sensorItem.sensor_type.data_key_name
          });
        }
      });
    });
    setSensorsList(newSensorsList);
  }, [sensorsResponse]);

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: defaultValues,
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/directories/equipment_items/${equipmentId}/sensors`
  );

  // Обновление списка устройств при получении ответа и закрытие формы
  useEffect(() => {
    if (saveResponse) {
      updateList();
      reset();
    }
  }, [saveResponse]);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          sensor_id: sensor === null ? null : Number(formData.sensor.value),
          equipment_item_connected_at: `${new Date(formData.at).getFullYear()}-${
            new Date(formData.at).getMonth() + 1
          }-${new Date(formData.at).getDate()} 01:00:00 +0300`,
          idle_level: formData.idle_level === "" ? "0" : formData.idle_level,
        },
      },
    });
  };

  function handleChangeDevice(
    value: React.SetStateAction<{ label: string; value: string | number } | undefined> | null,
    onChange: (...event: any[]) => void
  ) {
    onChange(value);
    if (value) setDevice(value);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col w-full gap-1 bg-muted p-4 rounded">
        <div className="text-lg font-medium">{t("adding_equipment_device_sensor")}</div>
        <div className="text-sm">{t("adding_equipment_device_sensor_form_text")}</div>

        <div className="flex w-full items-end gap-4 mt-4">
          <div className="grid grid-cols-2 items-end w-full gap-4">
            <Controller
              name="device"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => {
                return (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("device")}*</Label>
                    <SelectButton
                      value={value}
                      searchable={true}
                      label={"Выберите устройство"}
                      options={devicesList}
                      onChange={(e) => handleChangeDevice(e, onChange)}
                    />
                  </div>
                );
              }}
            />
            <Controller
              name="sensor"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => {
                return (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("sensor")}*</Label>
                    <SelectButton
                      value={value}
                      searchable={true}
                      label={"Выберите датчик"}
                      options={sensorsList!}
                      onChange={(e) => handleChangeDevice(e, onChange)}
                    />
                  </div>
                );
              }}
            />
          </div>

          <Button type="submit" size={"sm"}>
            {t("connect")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddDevice;
